import React from 'react';
import { FaUser, FaIdCard, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const BillingAddress = ({ billingAddress = {}, showTittle = false }) => {
    return (
        <div className="mt-3 d-flex flex-column gap-2 text-muted small">
            {showTittle && <h2 className="mb-3 fs-4">Datos de Facturación</h2>}
            <div className="d-flex align-items-center gap-2 mb-2">
                <FaUser className="text-primary" />
                <span>
                    <strong>Nombre:</strong> {billingAddress.name || ''}
                </span>
            </div>

            <div className="d-flex align-items-center gap-2 mb-2">
                <FaIdCard className="text-primary" />
                <span>
                    <strong>Doc. Ced/RUC:</strong> {billingAddress.taxDocId || billingAddress.docId || ''} ({billingAddress.type === 'J' ? 'Jurídica' : billingAddress.type === 'NF' ? 'Extranjero' : 'Natural'})
                </span>
            </div>

            <div className="d-flex align-items-center gap-2 mb-2">
                <FaPhone className="text-primary" />
                <span>
                    <strong>Teléfono:</strong> {billingAddress.phoneNumber || ''}
                </span>
            </div>

            <div className="d-flex align-items-center gap-2 mb-2">
                <FaEnvelope className="text-primary" />
                <span>
                    <strong>Correo:</strong> {billingAddress.email || ''}
                </span>
            </div>

            <div className="d-flex align-items-center gap-2 mb-2">
                <FaMapMarkerAlt className="text-primary" />
                <span>
                    <strong>Dirección:</strong> {billingAddress.address1 || ''}
                </span>
            </div>
        </div>
    );
};

export default BillingAddress;
